import React from "react";
import { Grid } from "@material-ui/core";
import IngameLT from "./IngameLT";

const IngameLTPage = () => {
  return (
    <div>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={4}>
          <IngameLT />
        </Grid>
        {/* <Grid item xs={12} sm={12} md={6} lg={4}>
          <CasterSelection />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <CasterSelection alt />
        </Grid> */}
        {/* <Grid item xs={12} sm={12} md={6} lg={4}>
          <ControlTimer />
        </Grid> */}
      </Grid>
    </div>
  );
};

export default IngameLTPage;
